import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import './App.scss';
import Public from './public/components/Public';
import Protected from './public/components/protected/Protected';
import Login from './public/components/login/Login';
import { RouteNames } from './public/enums/RouteNames';
import Authenticate from './public/components/login/authenticate/Authenticate';
import ErrorPage from './public/pages/error-page/ErrorPage';
import AutomaticLogin from './public/components/login/automatic-login/AutomaticLogin';

const App = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary
        FallbackComponent={ErrorPage}
      >
        <Routes>
          <Route
            path={RouteNames.AUTHENTICATE}
            element={<Authenticate />}
          />
          <Route
            path={RouteNames.LOGIN}
            element={<Login />}
          />
          <Route
            path={RouteNames.AUTOMATIC_LOGIN}
            element={<AutomaticLogin />}
          />
          <Route
            path='/*'
            element={
              <Protected element={
                <Public />
              } />
            }
          />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
